import { RULES } from '../config/competition'
import { compactMoney, countdown, duration } from '../core/format'
import type { CompetitionState } from '../core/types'
import { RUNTIME } from '../config/runtime'
import { LiveDot } from './primitives/Bits'
import { XMark } from './primitives/XMark'

const STATUS_LABEL: Record<string, string> = {
  live: 'LIVE',
  connecting: 'SYNCING',
  stalled: 'STALLED',
  offline: 'OFFLINE',
}

export function TopBar({ state, now }: { state: CompetitionState; now: number }) {
  const { meta } = state
  const standby = meta.phase === 'standby'
  const elapsed = Math.max(0, now - meta.startedAt)
  const total = Math.max(1, meta.endsAt - meta.startedAt)
  const progress = standby ? 0 : Math.min(1, elapsed / total)

  return (
    <header className="topbar">
      <div className="topbar__brand">
        <span className="topbar__mark" aria-hidden="true">
          UTC
        </span>
        <span className="topbar__title">ULTIMATE TRADING COMPETITION</span>
        <a
          className="topbar__social"
          href={RUNTIME.social.url}
          target="_blank"
          rel="noreferrer"
          title={`@${RUNTIME.social.handle} on X`}
        >
          <XMark size={11} />
          <span>@{RUNTIME.social.handle}</span>
        </a>
      </div>

      <div className="topbar__round">
        <span className="u-label">ROUND {String(meta.round).padStart(2, '0')}</span>
        <div className="topbar__progress" title={`${(progress * 100).toFixed(1)}% elapsed`}>
          <span style={{ width: `${progress * 100}%` }} />
        </div>
        <span className="topbar__clock u-num">
          {standby ? duration(RULES.durationHours) : countdown(meta.endsAt - now)}
        </span>
        <span className="u-label">{standby ? 'ON THE CLOCK' : 'REMAINING'}</span>
      </div>

      <div className="topbar__meta">
        <span className="topbar__kv">
          <span className="u-label">SEED</span>
          <span className="u-num">{compactMoney(RULES.seedCapital)} / AGENT</span>
        </span>

        {/* The rail carries real exchange data or nothing, so this says which. */}
        <span className="topbar__kv" title={meta.priceSource || 'no price feed'}>
          <span className="u-label">PRICES</span>
          <span className={`u-num ${meta.prices === 'live' ? 'u-up' : ''}`}>
            {meta.prices === 'live' ? 'LIVE' : 'OFFLINE'}
          </span>
        </span>

        <span className={`topbar__status ${standby ? 'is-standby' : `is-${meta.status}`}`}>
          <LiveDot status={standby ? 'standby' : meta.status} />
          {standby ? 'STANDBY' : (STATUS_LABEL[meta.status] ?? meta.status.toUpperCase())}
        </span>
      </div>
    </header>
  )
}
